import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ContactPage.css';

const ContactPage: React.FC = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');
    
    try {
      // TODO: Implement actual form submission
      await new Promise(resolve => setTimeout(resolve, 1000));
      setStatus('success');
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <h1>{t('contactUs')}</h1>
        
        <div className="contact-content">
          <div className="contact-info">
            <h2>{t('getInTouch')}</h2>
            <p>{t('contactDescription')}</p>
            
            <div className="contact-details">
              <div className="contact-item">
                <h3>{t('email')}</h3>
                <p>contact@whomii.com</p>
              </div>
              
              <div className="contact-item">
                <h3>{t('address')}</h3>
                <p>{t('companyAddress')}</p>
              </div>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">{t('name')}</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">{t('email')}</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">{t('subject')}</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">{t('message')}</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows={5}
              />
            </div>

            <button 
              type="submit" 
              className="submit-button"
              disabled={status === 'sending'}
            >
              {status === 'sending' ? t('sending') : t('sendMessage')}
            </button>

            {status === 'success' && (
              <div className="success-message">
                {t('messageSentSuccess')}
              </div>
            )}

            {status === 'error' && (
              <div className="error-message">
                {t('messageSentError')}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactPage; 